module.exports = __webpack_public_path__ + "img/anger.5293fed3.svg";